import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import {
    GET_SDPU_STORE_INFO,
    SET_STORE_INFO_TO_LOCAL_STORAGE,
} from '../actionTypes/SdpuStoreInfoTypes';

function SdpuStoreInfoReducer(state = {}, action) {
    switch (action.type) {
        case GET_SDPU_STORE_INFO: {
            const {
                storeId: id,
                storeName: name,
                zipCode,
                curbsidePickupIndicator,
            } = action.payload;
            return {
                ...state,
                name,
                id,
                zipCode,
                curbsidePickupIndicator,
            };
        }
        case SET_STORE_INFO_TO_LOCAL_STORAGE: {
            LocalStorage.setData(
                'SDPUStoreInfo',
                {
                    storeId: state.id,
                    storeName: state.name,
                    zipCode: state.zipCode,
                    curbsidePickupIndicator: state.curbsidePickupIndicator,
                },
                true
            );
            return state;
        }
        default: {
            return state;
        }
    }
}

SdpuStoreInfoReducer.reducerName = 'sdpuStoreInfo';

export default SdpuStoreInfoReducer;
